import { Dialog } from "@mui/material";
import styles from "./FbWarning.module.scss";
import {
  CloseIcon,
  LoginMailIcon,
  PhoneIcons,
} from "@features/common/SvgIcons";

interface FbWarningDialogProps {
  open: boolean;
  onClose: any;
}

/**
 * @method Confirm
 * @description A common component usding as a confirmation dialog
 * @param param0
 * @returns
 */
const FbWarning = ({ open, onClose }: FbWarningDialogProps) => {
  const onCloseClick = (isConfirm = false) => {
    onClose && onClose(isConfirm);
  };

  const handleBackDropClick = () => {
    onClose && onClose(false);
  };

  return (
    <Dialog
      open={open}
      className={`fb-warning-dialog ${styles["fb-warning-dialog"]}`}
      onClose={handleBackDropClick}
    >
      <div
        className={`fb-warning-dialog-container ${styles["fb-warning-dialog__container"]}`}
      >
        <div
          className={`${styles["fb-warning-dialog__close-btn"]}`}
          onClick={() => onCloseClick(false)}
        >
          <CloseIcon />
        </div>

        <span className={`${styles["fb-warning-dialog__help-center"]}`}>
          Help Center
        </span>

        <span className={`${styles["fb-warning-dialog__help"]}`}>
          In case you need help with recovering your email address, please
          contact us.
        </span>

        <div className={styles["phone-list-container"]}>
          <div className={styles["phone-list-container__item"]}>
            <div className={styles["phone-list-container__item__left"]}>
              <PhoneIcons />
              <span className={styles["country-name"]}>UAE</span>
              <span className={styles["phone"]}>600 54 2222</span>
            </div>
            <div className={styles["phone-list-container__item__right"]}>
              <span className="country-name">Every day 9AM - 10PM</span>
            </div>
          </div>
          <div className={styles["phone-list-container__item"]}>
            <div className={styles["phone-list-container__item__left"]}>
              <PhoneIcons />
              <span className={styles["country-name"]}>KSA</span>
              <span className={styles["phone"]}>+966 9200 00175</span>
            </div>
            <div className={styles["phone-list-container__item__right"]}>
              <span className="country-name">Every day 9AM - 10PM</span>
            </div>
          </div>
          <div className={styles["phone-list-container__item"]}>
            <div className={styles["phone-list-container__item__left"]}>
              <PhoneIcons />
              <span className={styles["country-name"]}>Kuwait</span>
              <span className={styles["phone"]}>+965 22204519</span>
            </div>
            <div className={styles["phone-list-container__item__right"]}>
              <span className="country-name">Every day 9AM - 10PM</span>
            </div>
          </div>
        </div>
        <div
          className={styles["phone-list-container"]}
          style={{ marginTop: "8px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            <LoginMailIcon />
            help@yougotagift.com
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default FbWarning;
